"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebSocketClientTransport = exports.RandomMessageID = void 0;
var wsclient_1 = require("../wsclient");
var logger_1 = require("../../logger");
var auth_1 = require("../auth");
var transport_websocket_1 = require("../transport.websocket");
var dispatcher_1 = require("../../dispatcher");
function RandomMessageID(prefix) {
    if (prefix === void 0) { prefix = ''; }
    return prefix + 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}
exports.RandomMessageID = RandomMessageID;
var headersUpdatedPrefix = 'headersupdate-';
var WebSocketClientTransport = (function () {
    function WebSocketClientTransport(endpoint, marshaller, logger, protocols) {
        if (protocols === void 0) { protocols = []; }
        this._supported = !!window['WebSocket'];
        if (!this._supported) {
            return;
        }
        this._logger = logger;
        this._marshaller = marshaller;
        this._wsc = new wsclient_1.WSClient();
        this._wsc.open(endpoint, protocols);
        this.onOpen = this.onOpen.bind(this);
        this.onMessage = this.onMessage.bind(this);
        this.onClose = this.onClose.bind(this);
        this.onConnecting = this.onConnecting.bind(this);
        this._requests = {};
        this._wsc.onDisconnect = this.onClose;
        this._wsc.onMessage = this.onMessage;
        this._wsc.onConnect = this.onOpen;
        this._wsc.onConnecting = this.onConnecting;
        this._headersUpdated = true;
        this._dispatcher = new dispatcher_1.Dispatcher();
    }
    WebSocketClientTransport.prototype.isReady = function (checkHeaders) {
        if (checkHeaders === void 0) { checkHeaders = true; }
        if (!this._supported) {
            return false;
        }
        if (checkHeaders && !this._headersUpdated) {
            return false;
        }
        return this._wsc.state === wsclient_1.WSClientState.Connected;
    };
    WebSocketClientTransport.prototype.send = function (service, method, data) {
        var _this = this;
        var request = {
            service: service,
            method: method,
            kind: transport_websocket_1.WebSocketMessageKind.RpcRequest,
            id: RandomMessageID(),
            data: data.serialize()
        };
        this._logger.logf(logger_1.LogLevel.Trace, '====================================================\nOutgoing message:\n', request);
        var serialized = this._marshaller.Marshal(request);
        var onFailure = this.onFailure;
        var record = {
            service: service,
            method: method,
            timeout: window.setTimeout(function () {
                var error = 'timed out request to ' + service + '/' + method;
                if (onFailure) {
                    onFailure(service, method, error);
                }
                record.reject(new Error(error));
                delete _this._requests[request.id];
            }, 60000)
        };
        record.promise = new Promise(function (resolve, reject) {
            record.reject = reject;
            record.resolve = resolve;
        });
        this._requests[request.id] = record;
        this._wsc.send(serialized);
        if (this.onSend) {
            this.onSend(service, method, serialized);
        }
        return record.promise;
    };
    WebSocketClientTransport.prototype.checkHeaders = function () {
        if (!this.isReady(false)) {
            return;
        }
        if (this._auth) {
            this.sendHeaders();
            return;
        }
        this._headersUpdated = true;
    };
    WebSocketClientTransport.prototype.sendHeaders = function () {
        this._headersUpdateID = RandomMessageID(headersUpdatedPrefix);
        var headers = __assign({}, this._headers);
        if (this._auth) {
            headers['Authorization'] = this._auth.toValue();
        }
        var msg = {
            headers: headers,
            kind: transport_websocket_1.WebSocketMessageKind.RpcRequest,
            id: this._headersUpdateID,
        };
        var serialized = this._marshaller.Marshal(msg);
        this._logger.logf(logger_1.LogLevel.Trace, '====================================================\Updating headers...\n', JSON.stringify(msg, null, '    '));
        this._wsc.send(serialized);
    };
    WebSocketClientTransport.prototype.getHeaders = function () {
        return this._headers;
    };
    WebSocketClientTransport.prototype.setHeaders = function (headers) {
        this._headers = headers || {};
    };
    WebSocketClientTransport.prototype.getAuthorization = function () {
        return this._auth ? this._auth.method : undefined;
    };
    WebSocketClientTransport.prototype.setAuthorization = function (method) {
        if (!method) {
            this._auth = undefined;
        }
        this._auth = new auth_1.Authorization();
        this._auth.method = method;
        this.checkHeaders();
    };
    WebSocketClientTransport.prototype.onConnecting = function () {
        this._headersUpdated = false;
    };
    WebSocketClientTransport.prototype.onClose = function () {
        this._headersUpdated = false;
    };
    WebSocketClientTransport.prototype.onHeadersUpdated = function (res) {
        if (res.ref === this._headersUpdateID) {
            if (res.kind === transport_websocket_1.WebSocketMessageKind.RpcFailure) {
                this._logger.logf(logger_1.LogLevel.Error, "Headers update failed. Ref: ".concat(res.ref), res.data);
            }
            this._headersUpdated = true;
            return true;
        }
        return false;
    };
    WebSocketClientTransport.prototype.onRpcResponseMessage = function (res) {
        if (!(res.ref in this._requests)) {
            if (!this.onHeadersUpdated(res)) {
                if (res.ref.indexOf(headersUpdatedPrefix) === 0) {
                    this._logger.logf(logger_1.LogLevel.Debug, 'Outdated headers update ID came back: ' + res.ref, res);
                }
                else {
                    this._logger.logf(logger_1.LogLevel.Warning, 'Unknown reference ID came back: ' + res.ref, res);
                }
            }
            return;
        }
        var record = this._requests[res.ref];
        delete this._requests[res.ref];
        clearTimeout(record.timeout);
        if (res.kind === transport_websocket_1.WebSocketMessageKind.RpcFailure) {
            if (this.onFailure) {
                this.onFailure(record.service, record.method, res.data);
            }
            record.reject(res.data);
        }
        else {
            if (this.onSuccess) {
                this.onSuccess(record.service, record.method, res.data);
            }
            record.resolve(res.data);
        }
    };
    WebSocketClientTransport.prototype.onFailureMessage = function (res) {
        this._logger.logf(logger_1.LogLevel.Error, "Server was unable to process a request. Error: ".concat(res.cause), res.data);
    };
    WebSocketClientTransport.prototype.onBuzzerRequestMessage = function (req) {
        var _this = this;
        this._logger.logf(logger_1.LogLevel.Debug, 'Incoming buzzer call:', req);
        var res = {
            kind: transport_websocket_1.WebSocketMessageKind.BuzzerResponse,
            ref: req.id,
            data: undefined,
        };
        this._dispatcher.dispatch(this._context, req.service, req.method, req.data)
            .then(function (data) {
            res.data = data;
            _this._wsc.send(JSON.stringify(res));
        })
            .catch(function (err) {
            res.kind = transport_websocket_1.WebSocketMessageKind.BuzzerFailure;
            res.data = err;
            _this._wsc.send(JSON.stringify(res));
        });
    };
    WebSocketClientTransport.prototype.onStreamS2CMessage = function (res) {
        this._logger.logf(logger_1.LogLevel.Warning, 'Incoming S2C stream, not supported!', res);
    };
    WebSocketClientTransport.prototype.onMessage = function (data) {
        var deserialized = this._marshaller.Unmarshal(data);
        this._logger.logf(logger_1.LogLevel.Trace, '====================================================\nIncoming message:\n', data);
        switch (deserialized.kind) {
            case transport_websocket_1.WebSocketMessageKind.RpcResponse:
                this.onRpcResponseMessage(deserialized);
                break;
            case transport_websocket_1.WebSocketMessageKind.RpcFailure:
                this.onRpcResponseMessage(deserialized);
                break;
            case transport_websocket_1.WebSocketMessageKind.BuzzerRequest:
                this.onBuzzerRequestMessage(deserialized);
                break;
            case transport_websocket_1.WebSocketMessageKind.Failure:
                this.onFailureMessage(deserialized);
                break;
            case transport_websocket_1.WebSocketMessageKind.StreamS2C:
                this.onStreamS2CMessage(deserialized);
                break;
            default:
                this._logger.logf(logger_1.LogLevel.Error, 'Invalid message received, kind is unknown or not supported.', data);
        }
    };
    WebSocketClientTransport.prototype.onOpen = function () {
        this.checkHeaders();
    };
    WebSocketClientTransport.prototype.registerBuzzer = function (buzzer) {
        return this._dispatcher.register(buzzer);
    };
    WebSocketClientTransport.prototype.unregisterBuzzer = function (id) {
        return this._dispatcher.unregister(id);
    };
    WebSocketClientTransport.prototype.setContext = function (context) {
        this._context = context;
    };
    WebSocketClientTransport.prototype.getContext = function () {
        return this._context;
    };
    return WebSocketClientTransport;
}());
exports.WebSocketClientTransport = WebSocketClientTransport;
//# sourceMappingURL=transport.websocket.client.js.map